import type { Composer } from 'vue-i18n';
import type { Locale } from '#i18n';

export default defineNuxtPlugin({
  name: 'i18n',
  dependsOn: ['i18n:plugin', 'observability'],
  setup(nuxtApp) {
    const i18n = nuxtApp.$i18n as Composer;
    const o11y = useO11y();

    if (!i18n || !o11y) {
      console.error('i18n or observability plugin not found. Ensure both plugins are properly registered.');
      return;
    }

    const originalMissingHandler = i18n.getMissingHandler();

    i18n.setMissingHandler((locale, key, instance, values) => {
      if (shouldSkipReporting(locale, i18n.fallbackLocale.value as Locale, key)) return;

      // Report to Datadog
      o11y.reportError(new Error(`Missing translation for key "${key}" in locale "${locale}"`));

      // Call original handler if it exists
      if (originalMissingHandler) {
        originalMissingHandler(locale, key, instance, values);
      } else if (process.env.NODE_ENV !== 'production') {
        // Default warning behavior
        console.warn(`[vue-i18n] Missing translation: '${key}' in locale '${locale}'`);
      }
    });
  },
});

function shouldSkipReporting(locale: Locale, fallbackLocale: Locale, key: string): boolean {
  if (locale !== fallbackLocale && key.startsWith('assets.')) return true; // Assets always use fallback locale, so skip reporting
  return false;
};
